import { useMemo } from 'react';
import { useMediaQuery } from '@mantine/hooks';

export interface ChartMargins {
  top: number;
  right: number;
  left: number;
  bottom: number;
}

interface ChartLayout {
  margins: ChartMargins;
  yAxisWidth: number;
  contentLeftOffset: number;
  contentWidth: string;
}

export const useChartLayout = (baseMargins: ChartMargins): ChartLayout => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return useMemo(() => {
    const yAxisWidth = isMobile ? 30 : 40;
    const minLeftMargin = isMobile ? 30 : baseMargins.left;
    const minRightMargin = isMobile ? 10 : baseMargins.right;

    const margins = {
      top: baseMargins.top,
      right: Math.max(minRightMargin, baseMargins.right),
      left: Math.max(minLeftMargin, baseMargins.left),
      bottom: baseMargins.bottom
    };

    const contentLeftOffset = margins.left + yAxisWidth;
    const contentWidth = `calc(100% - ${contentLeftOffset + margins.right}px)`;

    return {
      margins,
      yAxisWidth,
      contentLeftOffset,
      contentWidth
    };
  }, [isMobile, baseMargins.top, baseMargins.right, baseMargins.left, baseMargins.bottom]);
};
